import { render } from "./payment-details.vue?vue&type=template&id=9d0b2fd0&scoped=true"
import script from "./payment-details.vue?vue&type=script&lang=js"
export * from "./payment-details.vue?vue&type=script&lang=js"

import "./payment-details.vue?vue&type=style&index=0&id=9d0b2fd0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d0b2fd0"]])

export default __exports__